<template>
  <div class="container mt-4 p-0 calendar-wrapper">
    <VCalendar
      v-model="selectedDate"
      :attributes="calendarAttributes"
      :locale="locale"
      @dayclick="handleDayClick"
      class="w-100"
    />
    <!-- Modal Bootstrap -->
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background:rgba(0,0,0,0.3)" @click.self="showModal = false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Eventet për: {{ formattedSelectedDate }}</h5>
            <button type="button" class="btn-close" @click="showModal = false"></button>
          </div>
          <div class="p-4 pt-0 pb-0">
            <ul v-if="eventsForSelectedDate.length" class="ms-0 ps-0">
              <li
                v-for="(event) in eventsForSelectedDate"
                :key="event.id"
                class="border-bottom"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <small class="text-muted"><b>Koha:</b> {{ formatDateTime(event.happeningTime) }}</small>
                    <div class="fw-bold mt-1">{{ event.title }}</div>
                    <div class="mt-1" v-if="event.description && event.description.trim() !== ''" v-html="event.description"></div>
                    <div class="mt-1" v-else><i>{{ event.title }}</i></div>
                  </div>
                  <div v-if="event.fileUrl" class="ms-3">
                    <a
                      :href="event.fileUrl"
                      download
                      class="btn btn-sm btn-outline-primary btn-primary text-white mt-2"
                    >
                      <i class="bi bi-download"></i> Shkarko
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            <p v-else>Nuk ka agjenda për këtë datë.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { usePostsStore } from '@/store/PostStore/postStore';
import { format } from 'date-fns';

export default {
  data() {
    return {
      postStore: usePostsStore(),
      webPage: '',
      language: 'AL',
      count: 0,
      categoryId: 1147,
      selectedDate: new Date(),
      showModal: false,
      locale: 'sq-AL',
    };
  },
  computed: {
    agendaData() {
      // Use the normalized structure from the store
      return this.postStore.agendaPosts.map(post => ({
        id: post.id,
        title: post.title,
        description: post.description,
        happeningTime: post.createdDate, // ISO string for grouping
        formattedDate: post.formattedDate, // dd.MM.yyyy for display
        fileUrl: post.fileUrl,
      }));
    },
    calendarAttributes() {
      // Group events by date
      const grouped = {};
      this.agendaData.forEach(item => {
        const date = item.happeningTime.split('T')[0];
        if (!grouped[date]) grouped[date] = [];
        grouped[date].push(item);
      });
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const eventAttributes = Object.keys(grouped).map(date => ({
        key: date,
        dates: new Date(date),
        dot: {
          color: 'blue',
          label: grouped[date].length,
        },
        popover: {
          label: grouped[date].map(ev => ev.title).join('\n'),
        },
        customData: grouped[date],
      }));
      const todayHighlight = {
        key: 'today-highlight',
        dates: today,
        highlight: {
          color: 'gold',
          fillMode: 'light',
          contentClass: 'today-highlight-content',
        },
      };
      return [...eventAttributes, todayHighlight];
    },
    selectedKey() {
      return this.selectedDate ? format(this.selectedDate, 'yyyy-MM-dd') : '';
    },
    eventsForSelectedDate() {
      const attr = this.calendarAttributes.find(a => a.key === this.selectedKey);
      return attr ? attr.customData : [];
    },
    formattedSelectedDate() {
      return this.selectedDate ? format(this.selectedDate, 'dd.MM.yyyy') : '';
    },
    isLoading() {
      return this.postStore.loading;
    },
    hasError() {
      return !!this.postStore.error;
    }
  },
  methods: {
    handleDayClick(day) {
      this.selectedDate = day.date;
      this.showModal = true;
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const isoString = dateString.replace(' ', 'T').split('.')[0];
      const date = new Date(isoString);
      if (isNaN(date)) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}.${month} ${hours}:${minutes}`;
    },
  },
  async created() {
    await this.postStore.getGetAgenda({
      webPage: this.webPage,
      language: this.language,
      count: this.count,
      categoryId: this.categoryId,
    });
  },
}; 
</script>

<style scoped>
::v-deep(.vc-day),
::v-deep(.vc-day-box) {
  height: 100%;
}
::v-deep(.vc-day-content) {
  height: 100% !important;
  /* opsionale për të mbushur plotësisht qelizën */
  display: flex;
  align-items: center;
  justify-content: center;
}

ul.ms-0.ps-0 {
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
}
::v-deep(.vc-highlight[data-key="today"]) {
  background-color: #b7f0b1 !important;
  border-radius: 50% !important;
}

::v-deep(.vc-popover-content) {
  white-space: pre-line !important;
}

::v-deep(.vc-dot){
  position:absolute !important;
  width:20px !important;
  height:5px !important;
}
.calendar-wrapper {
  width: 100%;
  height: 420px !important ; /* ose 100%, në varësi nga konteksti */
}
/*Kalendar Style*/
.calendar-wrapper {
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  height: 80vh; /* ose 100% nëse e do të mbushë gjithë prindin */
}

/* Siguron që VCalendar të zgjerohet në të gjithë lartësinë */
::v-deep(.vc-container) {
  width: 100%;
  height: 100%;
}

/* Organizim proporcional i javëve dhe ditëve */
::v-deep(.vc-weeks) {
  display: flow;
  flex-direction: column;
  height: 100%;
}

::v-deep(.vc-week) {
  display: flex;
  flex: 1 1 auto;
}

::v-deep(.vc-day) {
  flex: 1 1 auto;
  aspect-ratio: 1 / 1; /* ruan formën katrore të çdo dite */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* Qendron përmbajtja në mes të ditës */
::v-deep(.vc-day-content) {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

/* Stilet e tua ekzistuese */
ul.ms-0.ps-0 {
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
}

::v-deep(.vc-highlight[data-key="today"]) {
  background-color: #b7f0b1 !important;
  border-radius: 50% !important;
}

::v-deep(.vc-popover-content) {
  white-space: pre-line !important;
}

::v-deep(.vc-dot) {
  position: absolute !important;
  width: 20px !important;
  height: 5px !important;
}

</style>